import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';
import type { ReportViewDto, SaveReportViewDto, ReportLogAction } from '@/types/reportView.types';

export const reportViewApi = {
  /** GET /api/v1/report-views?reportKey=KEY */
  getViews: (reportKey: string) =>
    apiClient.get<ApiResponse<ReportViewDto[]>>('/report-views', { params: { reportKey } }),

  /** POST /api/v1/report-views — personal view */
  create: (dto: SaveReportViewDto) =>
    apiClient.post<ApiResponse<ReportViewDto>>('/report-views', dto),

  /** POST /api/v1/report-views/shared — shared view (permission-gated server-side) */
  createShared: (dto: SaveReportViewDto) =>
    apiClient.post<ApiResponse<ReportViewDto>>('/report-views/shared', dto),

  /** PUT /api/v1/report-views/{id} */
  update: (id: string, dto: SaveReportViewDto) =>
    apiClient.put<ApiResponse<ReportViewDto>>(`/report-views/${id}`, dto),

  /** PUT /api/v1/report-views/{id}/shared */
  updateShared: (id: string, dto: SaveReportViewDto) =>
    apiClient.put<ApiResponse<ReportViewDto>>(`/report-views/${id}/shared`, dto),

  /** DELETE /api/v1/report-views/{id} */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/report-views/${id}`),
};

/**
 * Fire-and-forget export/print audit log.
 * Swallows every error — logging must never break an export or print action.
 */
export function logReportAction(
  reportKey: string,
  action: ReportLogAction,
  rowCount: number,
  filterSummary?: string,
): void {
  apiClient
    .post<ApiResponse<void>>('/report-views/export-log', {
      reportKey,
      action,
      rowCount,
      filterSummary,
    })
    .catch(() => {});
}
